import React from 'react';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-settings.module.scss';
import Header from '../../../../../../../components/Stake/header';
import RfuelIcon from '../../../../../../../assets/images/tokens/rfuel.svg';
import stakeBackground from '../../../../../../../assets/stake/stake-more-rfuel.svg';
import StakeMore from '../../../../../../../components/Stake/stake-more';
import { RFUEL } from '../../../../../../../constants/blockchain-constants';

const StakeSettings = () => {
  return (
    <>
      <Header icon={RfuelIcon} title='RFUEL-Staking' />
      <div className={stylesParent.cardContent}>
        <div className={styles.body}>
          <StakeMore type={RFUEL} title='Pool Closed' image={stakeBackground} />
        </div>
      </div>
    </>
  );
};

export default StakeSettings;
